import React from 'react';
import CircleLogoWhite from '../../../../assets/images/Campaign/Colour/circle-logo-white.svg';
import { LanguageSelector } from '../../ColourHero/LanguageSelector/LanguageSelector';
import './MenuBar.scss';
import { StoreContext } from '../../../../store/StoreContext';
import { SupportedLanguage } from '../../../../types/SupportedLanguage';

export const MenuBar = () => {
  return (
    <div className="MenuBar">
      <div className="header-top">
        <StoreContext.Consumer>
          {
            store =>
              <div onClick={() => window.open(`/${store.currentLanguage === SupportedLanguage.Traditional_Chinese ? 'zh-hant/' : store.currentLanguage === SupportedLanguage.Simplified_Chinese ? 'zh-hans/' : ''}`, '_self')}>
                <img src={CircleLogoWhite} alt="circle-logo" />
              </div>
          }
        </StoreContext.Consumer>
         <LanguageSelector />
      </div>
    </div>
  );
};